

































































































































import WeaponCarryingDialog from "@/components/WeaponCarryingDialog.vue";
import { AppConstants, Models, apiService } from "@/core/Export";
import { date } from "quasar";
import { Component, Vue } from "vue-property-decorator";
import VueRecaptcha from "vue-recaptcha";
import NotActivePage from "./NotActivePage.vue";

import store from "@/store";
@Component({ components: { VueRecaptcha, NotActivePage, WeaponCarryingDialog } })
export default class RequestMainPage extends Vue {
  dateMask: string = "DD/MM/YYYY";
  tResidentIdentification: Models.TResidentIdentification;
  idNo: string = "";
  dob: string = "";
  year: any = "";
  isResdeintRouteGreenDialogVisible: boolean = false;
  isResdeintRouteRedDialogVisible: boolean = false;
  isMessagesDialogVisible: boolean = false;
  messageContent: string = "";
  messageAdditionalData: string = "";
  isCaptchaVerified: boolean = false;
  isSearchButtonPressed: boolean = false;
  isBlocked: boolean = false;
  ïsWeaponCarryingDialogVisible: boolean = false;
  model: any = null;
  lessThenYearMsg: Array<any>;

  constructor() {
    super();
    if (this.appEnv.isDevEnv) {
      //מסלול ירוק
      this.idNo = "327244208";
      //this.dob = '03/11/1953'

      //מסלול אדום
      this.idNo = "020916367";
      //this.dob = '19/12/1990'
    }
  }

  created() { }

  onCheckRequestForResident(e) {
    this.isSearchButtonPressed = true;
    e.preventDefault();

    let verfiyResidentForm = this.$refs.verfiyResidentForm as any;
    if (!this.isCaptchaVerified) return;
    verfiyResidentForm.validate().then((success) => {
      if (success) {
        this.onPreapareModel();
        this.appEnv.isBusy = true;
        apiService
          .post("PersonYear/VerifyResident", this.tResidentIdentification)
          .then((res) => {
            let result = res as any;
            if (result.response && result.response.isSuccess) {
              apiService.setHeaders(result.token, "", "", this.appEnv.authority);
              this.model = result.response.result;
              let responseMsgs = result.response.msgs.msgs;
              this.lessThenYearMsg = responseMsgs.filter(q => q["msgCode"] == "lessThenYear");
              this.chooseRequest();
            } else {
              this.appEnv.showErrorDialog(result.response.msgs.errors, true);
            }
            this.appEnv.isBusy = false;
          })
          .catch((err) => {
            this.appEnv.isBusy = false;
          });
      }
    });
  }

  onPreapareModel() {
    this.tResidentIdentification = new Models.TResidentIdentification();
    this.tResidentIdentification.idNo = this.idNo.trim();
    this.tResidentIdentification.year = this.year;

    let dob = null;
    if (!this.isDOBInAuthorization) {
      dob = this.appEnv.toUTC(`01/01/${this.dob}`);
    } else {
      dob = this.appEnv.toUTC(this.dob);
    }

    if (dob) {
      this.tResidentIdentification.dob = dob;
    }
  }

  chooseRequest(): void {
    if (this.model.isMultipleApprovals && !this.model.isBlocked) {
      this.ïsWeaponCarryingDialogVisible = true;
    } else {
      if (this.lessThenYearMsg.length > 0) {
        this.appEnv.showErrorDialog(this.lessThenYearMsg, true);
        return;
      }
      this.onNavigateResidentByStatusCode();
    }
  }

  onNavigateResidentByStatusCode() {
    let model = this.model;
    this.appEnv.requestParams.personId = model.personId;
    this.appEnv.requestParams.year = this.year;
    this.isBlocked = false;

    if (model.isBlocked) {
      this.isBlocked = true;
      this.isMessagesDialogVisible = true;
      return;
    }

    switch (model.status) {
      case AppConstants.Lanes.Red:
        this.isResdeintRouteRedDialogVisible = true;
        break;
      case AppConstants.Lanes.Green:
        if (this.systemData.systemSettings.is1312isRequiredInGreenLane) {
          this.appEnv.canViewRequestRouteGreenFormPage = true;
          this.$router.push({
            name: AppConstants.Routes.GreenRouteForm,
          });
        } else {
          this.isResdeintRouteGreenDialogVisible = true;
        }
        break;
      case AppConstants.RequestStatus.New:
        this.appEnv.canViewRequestContinuePage = true;
        this.appEnv.requestParams.requestId = model.requestId;
        this.$router.push({
          name: AppConstants.Routes.RedRouteContinue,
        });
        break;
      case AppConstants.RequestStatus.Paid:
        this.appEnv.canViewRequestApprovePage = true;
        this.appEnv.requestParams.requestNo = model.requestNo;
        this.appEnv.requestParams.requestId = model.requestId;
        this.$router.push({
          name: AppConstants.Routes.Approve,
          params: { email: model.email },
        });
        break;
      case AppConstants.RequestStatus.InProcess:
        this.messageContent = "בתהליך";
        if (this.isPaymentRequired) {
          this.messageAdditionalData =
            "הבקשה נמצאת בטיפול העירייה בסיום הטיפול במידה ונמצאת זכאי תקבל מייל לתשלום ומיד לאחר מכן תוכל להדפיס את אישור התושב";
        } else {
          this.messageAdditionalData =
            "הבקשה נמצאת בטיפול העירייה בסיום הטיפול במידה ונמצאת זכאי תקבל מייל ומיד לאחר מכן תוכל להדפיס את אישור התושב";
        }
        this.isMessagesDialogVisible = true;
        break;
      case AppConstants.RequestStatus.AfterCompleteDetails:
        this.messageContent = "אחרי השלמת פרטים";
        if (this.isPaymentRequired) {
          this.messageAdditionalData =
            "הבקשה נמצאת בטיפול העירייה בסיום הטיפול במידה ונמצאת זכאי תקבל מייל לתשלום ומיד לאחר מכן תוכל להדפיס את אישור התושב";
        } else {
          this.messageAdditionalData =
            "הבקשה נמצאת בטיפול העירייה בסיום הטיפול במידה ונמצאת זכאי תקבל מייל ומיד לאחר מכן תוכל להדפיס את אישור התושב";
        }
        this.isMessagesDialogVisible = true;
        break;
      case AppConstants.RequestStatus.Rejected:
        this.messageContent = "נדחה";
        this.isMessagesDialogVisible = true;
        break;
      case AppConstants.RequestStatus.InIRSCheck:
        this.messageContent = "בתהליך אישור מס הכנסה";
        if (this.isPaymentRequired) {
          this.messageAdditionalData =
            "הבקשה נמצאת בטיפול העירייה בסיום הטיפול במידה ונמצאת זכאי תקבל מייל לתשלום ומיד לאחר מכן תוכל להדפיס את אישור התושב";
        } else {
          this.messageAdditionalData =
            "הבקשה נמצאת בטיפול העירייה בסיום הטיפול במידה ונמצאת זכאי תקבל מייל ומיד לאחר מכן תוכל להדפיס את אישור התושב";
        }
        this.isMessagesDialogVisible = true;
        break;
      case AppConstants.RequestStatus.Approved:
        this.messageContent = "אושר";
        if (this.isPaymentRequired) {
          this.messageAdditionalData = "במידה ולא קיבלת מייל לתשלום יש לפנות לעירייה";
        } else {
          this.messageAdditionalData = "במידה ולא קיבלת מייל יש לפנות לעירייה";
        }
        this.isMessagesDialogVisible = true;
        break;
      case AppConstants.RequestStatus.IncompleteDetails:
        this.messageContent = "בהשלמת פרטים";
        this.messageAdditionalData =
          'על מנת להשלים את הפרטים יש להפעיל את הקישור שנשלח אליך בדוא"ל';
        this.isMessagesDialogVisible = true;
        break;
      default:
        break;
    }
  }

  onValidateNumberInput(e) {
    let numRegex = new RegExp(/^\d+$/);
    if (!numRegex.test(e.key)) {
      e.preventDefault();
    }
  }

  onMessageDialogClosed() {
    this.messageContent = "";
    this.isMessagesDialogVisible = false;
  }

  onResidentRouteRedDialogClosed(isContinue: boolean) {
    if (isContinue) {
      this.appEnv.canViewRequestRouteRedPage = true;
      this.$router.push({
        name: AppConstants.Routes.RedRoute,
      });
    }
    this.isResdeintRouteRedDialogVisible = false;
  }

  onResidentRouteGreenDialogClosed(isContinue: boolean) {
    if (isContinue) {
      this.appEnv.canViewRequestRouteGreenPage = true;
      this.$router.push({
        name: AppConstants.Routes.GreenRoute,
      });
    }

    this.isResdeintRouteGreenDialogVisible = false;
  }

  onOpenUserManualLink() {
    window.open(this.userManualLink, "_blank");
  }
  onCaptchaVerified(e) {
    this.isCaptchaVerified = true;
  }

  onCaptchaExpired(e) {
    this.isCaptchaVerified = false;
  }

  get hasCaptchaVerifiedError() {
    return this.isSearchButtonPressed && !this.isCaptchaVerified;
  }

  extractDate(value) {
    if (value) return date.extractDate(value, "DD/MM/YYYY");
  }

  formatDate(value) {
    if (value) return date.formatDate(value, "DD/MM/YYYY");
  }

  get yearOptions() {
    this.year = this.systemData["years"][this.systemData["years"].length - 1];
    return this.systemData["years"];
  }

  get isDOBInAuthorization() {
    return this.systemData.systemSettings.isDOBInAuthorization;
  }

  get isNotActive() {
    return this.systemData.systemSettings.isNotActive;
  }

  get userManualLink() {
    return this.systemData.systemSettings.userManualLink;
  }

  get isPaymentRequired() {
    return this.systemData.systemSettings.isPaymentRequired;
  }

  get refferResidentToDep() {
    var val;
    if (this.systemData && this.systemData["systemSettings"]) {
      val = this.systemData["systemSettings"].refferResidentToDep;
    }
    if (!val) val = "לשירות לתושב";
    return val;
  }

  get systemData() {
    return store.getters.systemData;
  }

  get appEnv() {
    return store.getters.appEnv;
  }
}
